import request from "../helpers/request"

export const getNotifications = async (page = 1, perPage) => {
  const params = { page }
  if (perPage) params.per_page = perPage
  const response = await request.get("/api/company/notifications", { params })
  return response.data
}

export const markNotificationAsRead = async (notificationId) => {
  const response = await request.post(`/api/company/notifications/${notificationId}/mark-as-read`)
  return response.data
}

export const isNotificationUnread = (item) => {
  if (!item) return false
  if (item.read_at) return false
  if (item.is_read === true || item.is_read === 1) return false
  if (item.read === true) return false
  return true
}

export const resolveUnreadCount = (payload) => {
  const list = Array.isArray(payload?.data) ? payload.data : []
  const unreadInList = list.filter(isNotificationUnread).length
  const lastPage = Number(payload?.meta?.last_page) || 1
  const total = Number(payload?.meta?.total)
  const apiUnread = payload?.unread_count

  if (lastPage <= 1) return unreadInList
  if (typeof apiUnread === "number" && Number.isFinite(total) && apiUnread === total) {
    return unreadInList
  }
  if (typeof apiUnread === "number") return apiUnread
  return unreadInList
}

export const markAllNotificationsAsRead = async () => {
  const response = await request.post("/api/company/notifications/mark-all-as-read")
  return response.data
}

export const updateNotificationState = (count) => {
  const next = Math.max(0, Number(count) || 0)
  localStorage.setItem("notificationCount", String(next))
  window.dispatchEvent(new CustomEvent("notificationUpdate", { detail: { count: next } }))
}

export const getNotificationState = () => {
  return parseInt(localStorage.getItem("notificationCount") || "0")
}
